import React, { useState } from "react";
import { getAPI, postAPI } from "../../../helpers/httpHelper";
import { cognitoUserToken } from "../../../helpers/userHelper";
import { ROW_COUNT, API_CONTRATO, URL_SUPPORT, API_ADMIN_CONTRATISTA_SUBCONTRATISTA } from "../../../helpers/variableHelper";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import AdminLista from "../AdminLista";
import IContrato from "../../../entities/IContrato";
import { cParamsActiveOrderTitle } from "../../../helpers/paramsHelper";
interface IContratoProps {
  cbContrato?: Array<any>;
  items?: Array<any>;
}
const Contrato = ({ cbContrato, items }: IContratoProps) => {
  const userInfo = cognitoUserToken();
  const [pageSize, setPageSize] = useState(ROW_COUNT);
  const [token, setToken] = useState("");
  const [listItems, setListItems] = useState<Array<any>>([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [comboCsc, setComboCsc] = useState<Array<any>>(cbContrato || []);

  usePromiseEffect(async () => {
    setIsLoading(true);
    let token = await userInfo;
    setToken(token);
    let params = { PAGINA: 1, PAGINADO: pageSize, ORDENADOPOR: "ID", ORIENTACION: "DESC" };
    let result =
      items !== undefined
        ? { data: items, pages: 10 }
        : (await getAPI(`${URL_SUPPORT}${API_CONTRATO}/getall`, { Authorization: `Bearer ${token}` }, params)).result;

    let list = result.data;
    setListItems(list);
    let pages = result.pages;
    setPages(pages);
    const combo = (
      await getAPI(`${URL_SUPPORT}${API_ADMIN_CONTRATISTA_SUBCONTRATISTA}/getall`, { Authorization: `Bearer ${token}` }, cParamsActiveOrderTitle)
    ).result.data;
    setComboCsc(combo);
    setIsLoading(false);
  }, [token]);

  const edit = (value: IContrato, filters: any) => {
    delete value.FECHA_CREACION;
    delete value.TRANSACTION_ID;
    value.ID_CONTRATISTA_SUBCONTRATISTA = value.ID_CONTRATISTA_SUBCONTRATISTA ? value.ID_CONTRATISTA_SUBCONTRATISTA : 0;

    postAPI(`${URL_SUPPORT}${API_CONTRATO}`, value, { Authorization: `Bearer ${token}` })
      .then((result) => {
        let data = result.result.data;
        console.log(data);
        filter(filters, value?.ID > 0);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const paging = (page: any) => {
    setPage(page);
    let params = { PAGINA: page };
    filter(params, true);
  };

  const filter = (filter: any, havePage: boolean = false, size = pageSize) => {
    if (!filter) {
      filter = {};
      filter.PAGINA = 1;
    }
    filter.PAGINADO = size;
    if (filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    if (!havePage && filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    setPage(filter.PAGINA);
    if (filter.ORDENADOPOR === undefined) {
      filter.ORDENADOPOR = "ID";
      filter.ORIENTACION = "DESC";
    }
    getAPI(`${URL_SUPPORT}${API_CONTRATO}/getall`, { Authorization: `Bearer ${token}` }, filter)
      .then((result) => {
        setListItems(result.result.data);
        let pages = result.result.pages;
        setPages(pages);
      })
      .catch((error) => {});
  };

  return (
    <>
      <button
        data-testid="btnedit"
        hidden={true}
        onClick={() => {
          edit(
            {
              CODIGO_CONTRATO: "",
              CONTRATISTA_SUBCONTRATISTA: "",
              CORRELATIVO_PROVEEDOR: "",
              HIDECOLONEDIT: true,
              ACTIVO: "",
              ID: 1,
              ID_CONTRATISTA_SUBCONTRATISTA: 1,
              TITULO: "",
            },
            {}
          );
          paging(1);
        }}></button>
      <AdminLista
        items={[
          {
            type: "ID_CONTRATISTA_SUBCONTRATISTA",
            value: comboCsc.map((csc) => {
              return { text: csc.TITULO, value: csc.ID };
            }),
          },
        ]}
        reload={filter}
        filter={filter}
        pagination={{ pages: pages, page: page, paging: paging }}
        callback={edit}
        data={listItems}
        tipo={"Contrato"}
        title="Contrato"
        callbackUpdatePageSize={(pageSize: number, filters: Object) => {
          setPageSize(pageSize);
          filter(filters, false, pageSize);
        }}
        isLoading={isLoading}
      />
    </>
  );
};

export default Contrato;
